;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('shareSocialMedia', shareSocialMedia)

  function shareSocialMedia () {
    return {
      restrict: 'E',
      scope: {
        art: '<',
        socialMedia: '=',
        schedule: '='
      },
      templateUrl: '/arts/directives/share-social-media/share-social-media-directive.html?$$REVISION$$',
      controller: 'ShareSocialMediaController'
    }
  }
})()
